<template>
  <div style="padding:15px" class="containerTable">
    <vxe-toolbar
      id="toolbarId_fa2"
      :custom="{storage: true}"
      export
      :refresh="{query: RefreshList}"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('diyReportIndex_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('diyReportIndex_add_button')"
          @click="funcAdd"
        >
          新增
        </el-button>
        <el-button
          v-if="getLimit('diyReportIndex_export_button')" 
          @click="funcExport"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      show-footer
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList" 
    >
      <vxe-table-column
        type="checkbox"
        width="60"
        fixed="left"
      />
      <vxe-table-column>
        <vxe-table-column
          field="name"
          title="报表名称"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.name"
            placeholder="请输入报表名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="type"
          title="报表类型"
          :formatter="formatterType"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.type"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isDefault"
          title="是否是默认"
          :formatter="formatterIsDefault"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isDefault"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in isDefaultOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="remark"
          title="备注"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.remark"
            placeholder="请输入备注"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="创建时间"
          min-width="350"
          sortable
        />
        <template v-slot:header>
          <div class="block">
            <el-date-picker
              v-model="listQuery.gmtCreatedRange"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="optionsPicker"
              :default-time="['00:00:00', '23:59:59']"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'gmtCreated')"
            />
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column
        
        title="操作"
        min-width="260"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('diyReportIndex_detail_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcDetail(scope.row.code)"
            >
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('diyReportIndex_edit_button')"
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcEdit(scope.row.code)"
            >
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('diyReportIndex_delete_button')"
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcDelete(scope.row.code)"
            >
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('diyReportIndex_setting_button')"
            class="item"
            effect="dark"
            content="设置"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcSetReport(scope.row.code)"
            >
              <i class="el-icon-s-tools" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('diyReportIndex_view_button')"
            class="item"
            effect="dark"
            content="查看报表"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcViewReport(scope.row.code)"
            >
              <i class="el-icon-reading" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />

    <vxe-modal
      v-model="modelAddFlag"
      title="新增"
      width="500"
      height="450"
      resize
    >
      <compAdd
        ref="addRef"
        @fatherAddMethod="fatherAdd"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelEditFlag"
      title="编辑"
      width="500"
      height="450"
      resize
    >
      <compEdit
        ref="editRef"
        @fatherEditMethod="fatherEdit"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelDetailFlag"
      title="详情"
      width="500"
      height="550"
      resize
    >
      <compDetail ref="detailRef" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compAdd from './components/diyReportAdd.vue'
import compEdit from './components/diyReportEdit.vue'
import compDetail from './components/diyReportDetail.vue'
import request from '@/utils/request'
import { diyReport } from '@/api/financialStatistics'
export default {
    name: 'DiyReportList',
    components: {
        compAdd,
        compEdit,
        compDetail,
    },
    data() {
        return {
            message: '',
            loading: false,
            tableData: [],
            modelAddFlag: false,
            modelEditFlag: false,
            modelDetailFlag: false,
            copy: false,
            exportObj:{
              exportUrl:"/ntocc-tms-api/diyReport/exportDiyReport",//导出接口
              name:'自定义表'
            },
            listQuery: {
              gmtCreatedRange: '',
              code: '',
              branchCode: '',
              name: '',
              type: '',
              isDefault: '',
              remark: '',
              gmtCreatedStart: '',
              gmtCreatedEnd: '',
              pageNum: 1,
              pageSize: 20,
              sortField: '',
              sortType: '',
              total: 0,
            },
            // 报表类型
            typeOptions: [
                { label: '运输单', value: 0, color: 'gray' },
                { label: '订单', value: 1, color: '#0000ff' },
            ],
            // 是否默认
            isDefaultOptions: [
                { label: '否', value: 0, color: 'gray' },
                { label: '是', value: 1, color: '#0000ff' },
            ],
        }
    },
    created() {
        this.findList()
    },
    methods: {
        findList() {
            this.loading = true
            return new Promise((resolve) => {
                diyReport(this.listQuery).then((response) => {
                    this.tableData = response.data.records
                    this.listQuery.total = response.data.total
                    this.loading = false
                    resolve()
                })
            })
        },
        //设置报表
        funcSetReport(code) {
            this.$router.push({
                path: '/financialStatistics/diyReportSet',
                query: { code },
            })
        },
        //查看报表
        funcViewReport(code) {
            this.$router.push({
                path: '/financialStatistics/diyReportReal',
                query: { code },
            })
        },
        // 添加方法
        funcAdd() {
            this.modelAddFlag = true
        },
        // 修改方法
        funcEdit(code) {
            this.$refs.editRef.getInfo(code)
            this.modelEditFlag = true
        },
        // 详情方法
        funcDetail(code) {
            this.$refs.detailRef.getInfo(code)
            this.modelDetailFlag = true
        },
        // 删除方法
        funcDelete(row) {
            this.$confirm('确认删除吗？')
                .then((_) => {
                    request({
                        url: `/ntocc-tms-api/diyReport`,
                        method: 'delete',
                        params: { codes: row },
                    }).then((response) => {
                        this.$message({
                            message: response.msg,
                            type: 'success',
                        })
                        this.findList()
                    })
                })
                .catch((_) => {})
        },
        // 翻译报表类型
        formatterType({ cellValue }) {
            const item = this.typeOptions.find(
                (item) => item.value === cellValue
            )
            return item ? item.label : ''
        },
        // 翻译默认
        formatterIsDefault({ cellValue }) {
            const item = this.isDefaultOptions.find(
                (item) => item.value === cellValue
            )
            return item ? item.label : ''
        },
        // 增加组件的父方法
        fatherAdd() {
            this.modelAddFlag = false
            this.findList()
        },
        // 编辑组件的父方法
        fatherEdit() {
            this.modelEditFlag = false
            this.findList()
        },
        // 公共取消
        fatherCancel(modelFlag) {
            switch (modelFlag) {
                case 'add':
                    this.modelAddFlag = false
                    break
                case 'edit':
                    this.modelEditFlag = false
                    break
                case 'detail':
                    this.modelDetailFlag = false
                    break
                default:
            }
        },
        // 分页handle
        handlePageChange({ currentPage, pageSize }) {
            this.listQuery.pageNum = currentPage
            this.listQuery.pageSize = pageSize
            this.findList()
        },
    },
}
</script>

<style>
</style>
